export default __webpack_public_path__ + "static/media/bell-alerts.a2c98747.svg";